import { Component, OnInit } from '@angular/core';
import { AccountAppBarExpandedComponentData } from '../account-app-bar-expanded/account-app-bar-expanded.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountStateWidgetData } from '../account.model';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { readWrite, readOnly } from '../../user/user-permission/user-permission.data';
import { routerTransition } from '../../shared/animations/router.animations';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HorizontalListData } from 'common';
import { AccountEconomicsAdapter } from './account-economics.data';

@UntilDestroy()
@Component({
    selector: 'ifb-account-economics',
    templateUrl: './account-economics.component.html',
    styleUrls: ['./account-economics.component.scss'],
    providers: [AccountEconomicsAdapter],
    animations: routerTransition,
    standalone: false
})

export class AccountEconomicsComponent implements OnInit {
  accountStateWidgetData: AccountStateWidgetData = {};
  canEditBalances: boolean;
  canEditOffer: boolean;
  canReadOffer: boolean;
  canEditFacility: boolean;
  canReadFacility: boolean;
  data: AccountAppBarExpandedComponentData;
  offerListItems: HorizontalListData[];

  constructor(
    private readonly route: ActivatedRoute, 
    private readonly userPermissionService: UserPermissionService,
    private readonly adapter: AccountEconomicsAdapter,
    private readonly router: Router,
  ) {}

  ngOnInit(): void{
    this.route.data.pipe(untilDestroyed(this))
      .subscribe(this.dataSet.bind(this));

    this.userPermissionService.granted([readWrite('servicing-account-states')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canEditBalances = res);

    this.userPermissionService.granted([readWrite('servicing-account-offer')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canEditOffer = res);

    this.userPermissionService.granted([readOnly('servicing-account-offer')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canReadOffer = res);

      this.userPermissionService.granted([readWrite('servicing-account-facilities')])
        .pipe(untilDestroyed(this))
        .subscribe(res => this.canEditFacility = res);

      this.userPermissionService.granted([readOnly('servicing-account-facilities')])
        .pipe(untilDestroyed(this))
        .subscribe(res => this.canReadFacility = res);
  }

  dataSet(data: AccountAppBarExpandedComponentData): void {
    this.data = data;
    this.offerListItems = this.adapter.adaptOfferListData(this.data.account);
    this.accountStateWidgetData = {
      stateData: data.account.maintenanceState, // TODO: edit when other balances are implemented.
      availableFunds: data.account.maintenanceState?.availableBalance,
      lastMaintenanceDate: data.account.lastMaintenanceDate,
      utilization: data.account.maintenanceState?.utilization,
      lastReAmortizationDate: data.account.maintenanceState?.lastReAmortizationDate
    };
  }

  onEditOffer(): void {
    this.router.navigate(['offer'], { relativeTo: this.route });
  }
}
